import { seoLinks, absoluteUrl, ogImage } from "@/lib/seo";
import { createFileRoute } from "@tanstack/react-router";

import { PrivacyPolicyContent } from "@/components/site/EnrollmentPolicyContent";

import { PageHero, PolicyBody } from "../components/site/Page";

const title = "Integritetspolicy | Swedish International School";
const description =
  "Så behandlar Swedish International School Estepona–Marbella personuppgifter i ansökan, skolplacering och kontakt med vårdnadshavare.";

export const Route = createFileRoute("/integritetspolicy")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "article" },
      { property: "og:url", content: absoluteUrl("/integritetspolicy") },
      { name: "twitter:card", content: "summary" },
      { property: "og:locale", content: "sv_SE" },
      ...ogImage(),
    ],
    links: seoLinks("/integritetspolicy"),
  }),
  component: Integritetspolicy,
});

function Integritetspolicy() {
  return (
    <>
      <PageHero
        eyebrow="Integritet"
        title="Integritetspolicy"
        intro="Här beskriver vi vilka personuppgifter skolan samlar in via sajten och anmälningsformuläret, varför vi gör det och hur du kan påverka behandlingen."
      />

      <PolicyBody>
        <PrivacyPolicyContent locale="sv" />
      </PolicyBody>
    </>
  );
}
